import { types } from 'mobx-state-tree';

const ReserveInStoreService = types.model('ReserveInStoreService', {
  id: types.identifierNumber,
  description: types.maybeNull(types.string)
});

export default ReserveInStoreService;
